import styled from "@emotion/styled";

interface AddTokenButtonContainerProps {
  backgroundColor: string;
  isVisible: boolean;
}

export const AddTokenButtonContainer = styled.div<AddTokenButtonContainerProps>(
  ({ backgroundColor, isVisible }) => {
    return {
      visibility: isVisible ? "visible" : "hidden",
      borderRadius: "50%",
      backgroundColor,
      width: "22px",
      height: "22px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };
  }
);
